.card {
	border-radius: 9.23555px;
	position: relative;
	border: 1.3px solid #efefef;
	max-width: 1100px;
	min-width: 910px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
	margin-bottom: 20px;
}

.cardHeader {
	display: flex;
	align-items: center;
	gap: 10px;
	height: 50px;
	padding-left: 15px;
	background: #fcfcfc;
	border-bottom: 1.3px solid #efefef;
	border-radius: 9.23555px 9.23555px 0 0;
}

.cardIcon svg {
	fill: #0277ad;
}

.cardContent {
	margin: 20px 20px;
}

.cardContent p {
	font-size: 18px;
	font-weight: 400;
	line-height: 18px;
	margin: 20px 0px;
}

.card > ::-webkit-scrollbar {
	width: 12px;
	height: 12px;
}

.card > ::-webkit-scrollbar-track {
	background: #e8e8e8;
	box-shadow: none;
	border-radius: 8px;
}

.card > ::-webkit-scrollbar-thumb {
	background: #aaaaaa;
	border-radius: 12px;
	outline: none;
}

.card > ::-webkit-scrollbar-thumb:hover {
	background: #7c7c7c;
}

.statisticCard {
	padding: 5px 5px 5px 15px;
}

.statisticCardContent {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
}

.statisticCardHeader {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 5px;
	width: 100%;
}

.statisticCardHeader svg {
	width: 45px;
	height: 45px;
}

.statisticCardValue {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
}

.increaseBadge, .decreaseBadge, .neutralBadge {
	display: flex;
	align-items: center;
	gap: 2px;
	padding: 2px 4px;
	border-radius: 300px;
	font-size: 15px;
}

.increaseBadge {
	color: #387E25;
	background-color: #F5FAF2BF;
}

.decreaseBadge {
	color: #E00004;
	background-color: #FDF2F2;
}

.neutralBadge {
	color: #6E6E6E;
	background-color: #F8F8F8;
}
